
<template>
  <div ref="Dashboardpdf" id="Dashboardpdf">
    <section class="dashboard">
      <div>
        <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
        <!-- <loading
          :active.sync="isLoading"
          loader="spinner"
          color="#36304a"
          :width="70"
        ></loading> -->
      </div>

      <b-card class="mainCardBG" v-if="showDash == true">
        <b-button @click="previousPage" size="sm" variant="light">
          <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
        </b-button>`
        <b-row>
          <b-col md="3">
            <h4 class="page-title mb-1">FF Exp Dashboard</h4>
          </b-col>
          <b-col md="3">
            <date-range-picker
              class="mb-1"
              :opens="openLeft"
              :always-show-calendars="showCal"
              v-model="dateRange"
              :startDate="startDate"
              :endDate="endDate"
              :locale-data="locale"
              @update="viewTypeSize"
            >
            </date-range-picker>
          </b-col>
          <b-col md="2">
             <!-- &&  $sessionsStorage.get('nameUser') != 'Bhavneesh' -->
            <model-list-select
              class="mb-1"
              :list="branchList"
              id="branchfilter"
              v-model="branchfilter"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="All"
              @input="viewTypeSize"
              :isDisabled="$sessionsStorage.get('designation') != 'Admin'? true: false"
            ></model-list-select>
          </b-col>
          <b-col md="2">
            <model-list-select
              class="mb-1"
              :list="clientMaster"
              id="clientNamenew"
              v-model="clientIdFilter"
              option-value="clientId"
              option-text="clientName"
              placeholder="All"
              :isDisabled="$sessionsStorage.get('designation') != 'Admin'? true: false"
              @input="ClientDetails(clientIdFilter);viewTypeSize();"
            ></model-list-select>
          </b-col>
          <b-col md="3">
                <label>POD</label>
                <model-list-select
                  @input="
                    getLocationList($event, 'Sea_Port_NonIndia', 'getPortDischargeList');
                    viewTypeSize();
                  "
                  @searchchange="
                    getLocationList($event, 'Sea_Port_NonIndia', 'getPortDischargeList');
                  "
                  :list="getPortDischargeList.length>0?getPortDischargeList:$store.getters['common/getAllPODList']"
                  v-model="PODfilter"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder="Select POD"
                ></model-list-select>
              </b-col>
          <b-col md="1" class="text-right" v-if="clientIdFilter?true:false">
            <b-button class="mb-1 btn btn-sm" variant="outline-info" @click="ViewClientDetails(clientIdFilter)">View Client Details
            </b-button>
          </b-col>
          <b-col md="1" class="text-right">
            <b-button class="mb-1" variant="outline-info" @click="getPDF"><i class="fa fa-cloud-download" aria-hidden="true"></i>
            </b-button>
          </b-col>
        </b-row>
        <hr />
        <div class="gutr mt-3">
          <div class="row"  v-if="TotalShippedContEXP !=0 || Tot20STDTUESTypeCount !=0 || Tot40STDTUESTypeCount != 0">

            <div class="col-xl-3 col-sm-6 grid-margin stretch-card mb-2">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <div class="row">
                        <div class="col-md-12">
                          <h6 class="card-title">TOT. CONTAINERS TEUS EXP</h6>
                          <div class="fluid-container">
                            <table class="table mb-0">
                              <tbody>
                                <tr>
                                  <td>Execution</td>
                                  <td>CONTAINERS</td>
                                  <td>TEUS</td>
                                </tr>
                                <tr>
                                  <td><h4 class="card-title font-weight-bold mb-0">{{ totalExec }}</h4></td>
                                  <td><h4 class="card-title font-weight-bold mb-0">{{ TotalShippedContEXP }}</h4></td>
                                  <td><h4 class="card-title font-weight-bold mb-0">{{TotalShippedContEXPTUES}}</h4></td>
                                  <!-- <td><h4 class="card-title font-weight-bold mb-0">{{ Tot20STDTUESTypeCount+Tot40STDTUESTypeCount }}</h4></td> -->
                                </tr>
                              </tbody>
                            </table>
                            <!-- <h4 class="card-title font-weight-bold mb-0">
                              {{ TotalShippedContEXP }}
                            </h4> -->
                          </div>
                        </div>
                        <!-- <div class="col-md-6">
                          <h6 class="card-title">TOT. TEUS EXP</h6>
                          <div class="fluid-container">
                            <h4 class="card-title font-weight-bold mb-0">
                              {{ Tot20STDTUESTypeCount+Tot40STDTUESTypeCount }}
                            </h4>
                          </div>
                        </div> -->
                      </div>
                    </div>
                    <div>
                      <md-icon class="md-size-1x">import_export</md-icon>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mt-2">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h6 class="card-title">TOT. TYPE OF CONTAINER EXP</h6>
                      <div class="fluid-container">
                        <span class="card-title font-weight-bold mb-0">
                          20  = {{ Tot20STDTypeCount }}
                        </span><br/>
                        <span class="card-title font-weight-bold mb-0">
                          40  = {{ Tot40STDTypeCount }}
                        </span><br/>
                        <span class="card-title font-weight-bold mb-0">
                          LCL CONTAINERS : {{ TotLCL_Container_TotalShippedCont }}
                        </span>
                      </div>
                    </div>
                    <div>
                      <md-icon class="md-size-1x">import_export</md-icon>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card mt-2 ">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h6 class="card-title">TOTAL TEUS </h6>
                      <div class="fluid-container">
                        <span class="font-weight-bold mb-0">
                          {{ Tot20STDTypeCount }} * 1 = {{ Tot20STDTUESTypeCount }}
                        </span><br/>
                        <span class="font-weight-bold mb-0">
                          {{ Tot40STDTypeCount }} * 2 = {{ Tot40STDTUESTypeCount }}
                        </span> &nbsp;&nbsp; 
                        <span class="card-title font-weight-bold mb-0">
                         <b-badge variant="primary"> {{ Tot20STDTUESTypeCount }} </b-badge>+ <b-badge variant="primary">{{ Tot40STDTUESTypeCount }}</b-badge> =  <b-badge variant="danger">{{ Tot20STDTUESTypeCount+Tot40STDTUESTypeCount }}</b-badge>
                        </span><br/>
                        <span class="font-weight-bold mb-0">
                          LCL CONTAINERS : {{ TotLCLTUES_Container_TotalShippedCont }}
                        </span>
                      </div>
                    </div>
                    <div>
                      <md-icon class="md-size-1x">import_export</md-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div  v-if="totalExec != '0'" class="col-xl-5 col-md-6 grid-margin stretch-card mt-2">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h6 class="card-title">TOTAL CONTAINER TYPE EXP MODULES</h6>
                      <div class="fluid-container"></div>
                        <div id="chart">
                          <apexchart
                            v-if="showgraphsContainer == true"
                            type="pie"
                            class="mt-3"
                            width="530"
                            :options="chartOptions"
                            :series="series"
                          ></apexchart>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="topShippingLineContainerExportData > '0'" class="col-xl-4 col-md-6 grid-margin stretch-card">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h6 class="card-title">MOST EXP SLINE WISE CONTAINERS</h6>
                      <p class="card-description text-muted">TOP 7 (SHIPPING LINE Line)</p>
                      <div class="fluid-container">
                        <table class="table mb-0">
                          <tr>
                            <th>SLINE</th>
                            <th>CONTAINERS</th>
                            <th>TEUS</th>
                          </tr>
                          <tbody>
                            <tr
                              v-for="(item3, index) in topShippingLineContainerExportData"
                              :key="index"
                            >
                              <td class="pl-0" v-if="index<7" @click="ViewSlineDetails(item3.shippingId)">{{item3.shippingLine }}</td>
                              <td class="pr-0" v-if="index<7">
                                <b-badge variant="primary">{{
                                  item3.ContainerCount
                                }}</b-badge>
                              </td>
                              <td class="pr-0" v-if="index<7">
                                    <b-badge variant="danger"
                                    v-b-tooltip.hover 
                                    :title="'20` = '+item3.TUESSLine_Tot20STDTypeCount+' , 40` = '+item3.TUESSLine_Tot40STDTypeCount"><b>{{
                                      item3.SlineContainerTues_Count
                                    }}</b></b-badge>
                                  </td>
                            </tr>
                            </tbody>
                        </table>
                        <b-collapse id="collapse-SLine" v-model="slinevisible" class="mt-2">
                          <table class="table mb-0">
                              
                            <tbody>
                                <tr style="color:#fff">
                                  <th>SLINE</th>
                                  <th>CONTAINERS</th>
                                  <th>TEUS</th>
                                </tr>
                                <tr
                                  v-for="(item3, index) in topShippingLineContainerExportData"
                                  :key="index"
                                >
                                  <td class="pl-0"  v-if="index>=7"  @click="ViewSlineDetails(item3.shippingId)">{{ item3.shippingLine }}</td>
                                  <td class="pr-0"  v-if="index>=7">
                                    <b-badge variant="primary">{{
                                      item3.ContainerCount
                                    }}</b-badge>
                                  </td>
                                  <td class="pr-0" v-if="index>=7">
                                    <b-badge variant="danger"
                                    v-b-tooltip.hover 
                                    :title="'20` = '+item3.TUESSLine_Tot20STDTypeCount+' , 40` = '+item3.TUESSLine_Tot40STDTypeCount"
                                ><b>{{
                                      item3.SlineContainerTues_Count
                                    }}</b></b-badge>
                                  </td>
                                </tr>
                              </tbody>
                          </table>
                        </b-collapse>
                        <span v-if="topShippingLineContainerExportData.length>10"  
                          :class="slinevisible ? null : 'collapsed error'"
                          :aria-expanded="slinevisible ? 'true' : 'false'"
                          aria-controls="collapse-SLine"
                          @click="slinevisibleFun">VIEW MORE</span>
                      </div>
                        
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="topClientWiseContainerExportData > '0'" class="col-xl-4 col-md-6 grid-margin stretch-card">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h6 class="card-title">MOST EXP CLIENT WISE CONTAINERS</h6>
                      <p class="card-description text-muted">TOP 10 (CLIENT)</p>
                      <div class="fluid-container">
                        <table class="table mb-0">
                          <tr>
                            <th>CLIENT</th>
                            <th>CONTAINERS</th>
                            <th>TEUS</th>
                          </tr>
                          <tbody>
                            <tr
                              v-for="(item3, index) in topClientWiseContainerExportData"
                              :key="index"
                            >
                            
                              <td class="pl-0" v-if="index<10" @click="ViewClientDetails(item3.clientId)">{{ item3.ClientList }}</td>
                              <td class="pr-0" v-if="index<10">
                                <b-badge variant="primary">{{
                                  item3.ClientContainerCount
                                }}</b-badge>
                                
                              </td>
                              <td class="pr-0" v-if="index<10">
                                <b-badge variant="danger" 
                                v-b-tooltip.hover 
                                :title="'20` = '+item3.TUESCLIENT_Tot20STDTypeCount+' , 40` = '+item3.TUESCLIENT_Tot40STDTypeCount "><b>{{
                                  item3.ContainerTues_Count
                                }}</b></b-badge>
                                
                              </td>
                            </tr>
                          </tbody>
                        </table>
                          <b-collapse id="collapse-ClientList" v-model="clientvisible" class="mt-2">
                          <table class="table mb-0">
                            <tr style="color:#fff">
                              <th>CLIENT</th>
                              <th>CONTAINERS</th>
                              <th>TEUS</th>
                            </tr>
                            <tbody>
                                <tr
                                  v-for="(item3, index) in topClientWiseContainerExportData"
                                  :key="index"
                                >
                                  <td class="pl-0"  v-if="index>=10" @click="ViewClientDetails(item3.clientId)">{{ item3.ClientList }}</td>
                                  <td class="pr-0" v-if="index>=10">
                                    <b-badge variant="primary">{{
                                      item3.ClientContainerCount
                                    }}</b-badge>
                                  </td>
                                  <td class="pr-0" v-if="index>=10">
                                    <b-badge variant="danger" 
                                      v-b-tooltip.hover 
                                      :title="'20` = '+item3.TUESCLIENT_Tot20STDTypeCount+' , 40` = '+item3.TUESCLIENT_Tot40STDTypeCount "><b>{{
                                      item3.ContainerTues_Count
                                    }}</b></b-badge>
                                  </td>
                                </tr>
                              </tbody>
                          </table>
                        </b-collapse>
                        <span v-if="topClientWiseContainerExportData.length>10"  
                          :class="clientvisible ? null : 'collapsed error'"
                          :aria-expanded="clientvisible ? 'true' : 'false'"
                          aria-controls="collapse-ClientList"
                          @click="clientvisibleFun">VIEW MORE</span>
                      </div>
                        
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="topBranchWiseContainerExportData > '0'" class="col-xl-4 col-md-6 grid-margin stretch-card mt-2">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h6 class="card-title">MOST EXP BRANCH WISE CONTAINERS</h6>
                      <p class="card-description text-muted">TOP 10 (BRANCH)</p>
                      <div class="fluid-container">
                        <table class="table mb-0">
                          
                          <tbody>
                            <tr>
                              <th>BRANCH</th>
                              <th>CONTAINERS</th>
                              <th>TEUS</th>
                            </tr>
                            <tr
                              v-for="(item3, index) in topBranchWiseContainerExportData"
                              :key="index"
                            >
                              <td class="pl-0" v-if="index<10">{{ item3.BranchWise }}</td>
                              <td class="pr-0" v-if="index<10">
                                <b-badge variant="primary">{{
                                  item3.BranchContainerCount
                                }}</b-badge>
                              </td>
                              <td class="pr-0" v-if="index<10">
                                <b-badge variant="danger"><b>{{
                                  item3.BranchContainerTues_Count
                                }}</b></b-badge>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <b-collapse id="collapse-branchvisible" v-model="branchvisible" class="mt-2">
                          <table class="table mb-0">
                             <tr style="color:#fff">
                                <th>BRANCH</th>
                                <th>CONTAINERS</th>
                                <th>TEUS</th>
                              </tr>
                            <tbody>
                                <tr
                                  v-for="(item3, index) in topBranchWiseContainerExportData"
                                  :key="index"
                                >
                                  <td class="pl-0" v-if="index>=10">{{ item3.BranchWise }}</td>
                                  <td class="pr-0" v-if="index>=10">
                                    <b-badge variant="primary">{{
                                      item3.BranchContainerCount
                                    }}</b-badge>
                                  </td>
                                  <td class="pr-0" v-if="index>=10">
                                    <b-badge variant="danger"><b>{{
                                      item3.BranchContainerTues_Count
                                    }}</b></b-badge>
                                  </td>
                                </tr>
                              </tbody>
                          </table>
                        </b-collapse>
                        <span v-if="topBranchWiseContainerExportData.length>10"  
                          :class="branchvisible ? null : 'collapsed error'"
                          :aria-expanded="branchvisible ? 'true' : 'false'"
                          aria-controls="collapse-branchvisible"
                          @click="branchvisibleFun">VIEW MORE</span>
                      </div>
                        
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="top10ContainerTypeExportData.length > '0' && top10BranchesExportData.length>0" class="col-xl-12 col-md-8 grid-margin stretch-card mt-2">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h6 class="card-title">MOST EXP BRANCH WISE TYPE BASED CONTAINERS</h6>
                      <p class="card-description text-muted">TOP 10 (Branch)</p>
                      <div class="fluid-container"  style="overflow-x:auto;">
                        <!-- Perfect Data Arrya use Section Start -->
                        <!-- <table class="table mb-0 table-bordered">
                          <tbody>
                            <tr >
                              <td class="pl-0"  v-for="(item_CT, index_CT) in ContainertTypetemp_arr" :key="index_CT">
                                <b><b-badge variant="primary">{{ item_CT }}</b-badge></b>
                              </td>
                            </tr>
                            <tr  v-for="(item_CB, index_CB) in Comb_BranchCont[0]" :key="index_CB">
                              <td class="pl-0" >
                                <b><b-badge variant="primary">{{ index_CB }}</b-badge></b>
                              </td>
                              <td class="pl-0" v-for="(item, index) in item_CB" :key="index" >
                                <b><b-badge variant="primary">{{ item.BranchContainerCount }}</b-badge></b>
                                <b v-if="index_CB == 'Total Container'"><b-badge variant="primary">{{ item.Allcon_typewiseCount }}</b-badge></b>
                               <b v-if="(index_CB == 'Total Container'&&index ==ContainertTypetemp_arr.length-2)"><b-badge variant="primary">{{ item.Alltot_tues_cont }}</b-badge></b>
                                <b v-if="(index_CB == 'Total Container'&&index==ContainertTypetemp_arr.length-3)"><b-badge variant="primary">{{ item.AlltotContainerCount  }}</b-badge></b>
                                <b v-if="(index_CB != 'Total Container'&&index ==ContainertTypetemp_arr.length-2)"><b-badge variant="primary">{{ item.tot_tues_cont }}</b-badge></b><b v-if="(index_CB != 'Total Container'&&index == ContainertTypetemp_arr.length-3)"><b-badge variant="primary">{{ item.totContainerCount }}</b-badge></b>
                              </td>
                            </tr>
                          </tbody>
                        </table> -->
                        
                          <!-- Perfect Data Arrya use Section End -->



                        <span v-html="totalHtmlCont" >
                        {{this.totalHtmlCont}}
                        </span>
                        <!-- <table class="table mb-0 table-bordered">
                          <tbody>
                            <tr>
                              <td>BRANCH/CONTAINER TYPE</td>
                              <td class="pl-0" v-for="(item3_cont, index_cont) in top10ContainerTypeExportData"
                              :key="index_cont">
                              <b><b-badge variant="primary">{{ item3_cont.containerType }}</b-badge></b></td>
                            </tr>
                           
                            <tr v-for="(item3, index) in top10BranchesExportData" :key="index">
                              <td>{{item3.mainLocation}}</td>

                              <td class="pl-0" v-for="(item, ind) in top10ContainerTypeExportData"
                              :key="ind">
                                <b v-if="top10BranchWiseBaseContainerTyperow.length>0">
                                  <span class="pl-0" v-for="(item4, index4) in top10BranchWiseBaseContainerTyperow" :key="index4">
                                  <b-badge variant="primary" v-if="item3.mainLocation ==  item4.BranchWise && item.containerTypeId==item4.containerTypeId" >  {{ item4.BranchContainerCount }} </b-badge>
                                  <b-badge variant="danger" v-if="item.containerTypeId==item4.containerTypeId && index==(top10BranchesExportData.length-1)">{{TotalTUESCOUNT(item4.BranchContainerCount*item.tues_count,index,top10BranchesExportData.length-1)}} ABC</b-badge>
                                  </span>
                                </b>
                                
                                <b class="pr-0"  v-for="(item3Br, index3Br) in topBranchWiseContainerExportData"
                                :key="index3Br">
                                  <b-badge variant="danger" v-if="item3Br.BranchWise ==item3.mainLocation && ind==(top10ContainerTypeExportData.length-2)">{{
                                    item3Br.BranchContainerCount
                                  }}</b-badge>
                                </b>
                                
                                <b class="pr-0"  v-for="(item3Br2, index3Br2) in top10BranchWiseBaseContainerTyperow"
                                :key="index3Br2">
                                  <b-badge variant="primary" v-if="item3Br2.BranchWise == item3.mainLocation && ind==(top10ContainerTypeExportData.length-1)">{{TotalTUESCOUNT(item3Br2.BranchContainerCount*item3Br2.tues_count,ind,top10BranchesExportData.length-1)}}</b-badge>

                                  <span v-if="index3Br2 == 0 && item3.mainLocation == 'Chennai' && ind == top10ContainerTypeExportData.length-1"> {{ ggxd(item3Br2) + " " + item3Br2}} ABC </span>
                                </b>
                              </td>
                               <tr>
                            </tr>
                          </tbody>
                        </table> -->
                      </div>
                        
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="top10ContainerTypeExportData.length > '0' && top10SlinesExportData.length>0" class="col-xl-8 col-md-8 grid-margin stretch-card mt-2">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h6 class="card-title">MOST EXP SLINE WISE TYPE BASED CONTAINERS</h6>
                      <p class="card-description text-muted">TOP 10 (SLINE)</p>
                      <div class="fluid-container"  style="overflow-x:auto;">
                        <span v-html="totalSlineHtmlCont" >
                        {{this.totalSlineHtmlCont}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="top10ContainerTypeExportData.length > '0' && top10ClientWExportData.length>0" class="col-xl-8 col-md-8 grid-margin stretch-card mt-2">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h6 class="card-title">MOST EXP CLIENT WISE TYPE BASED CONTAINERS</h6>
                      <p class="card-description text-muted">TOP 10 (CLIENT)</p>
                      <div class="fluid-container"  style="overflow-x:auto;">
                        <span v-html="totalCLIENTHtmlCont" >
                        {{this.totalCLIENTHtmlCont}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="row" v-else>
            <div class="col-xl-12 col-sm-12 grid-margin stretch-card mb-2 text-center">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <!-- <div class="d-flex justify-content-between flex-wrap"> -->
                    <div class="row">
                      <div class="col-xl-4 col-sm-12 grid-margin">

                      </div>
                      <div class="col-xl-4 col-sm-12 grid-margin">
                          <center><h6 class="card-title error text-center">Data Not Found !</h6></center>
                      </div>
                      <div class="col-xl-4 col-sm-12 grid-margin">

                      </div>
                    </div>
                    
                  <!-- </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row gutr"></div>
      </b-card>
      <b-card v-else class="mainCardBG">
        <b-navbar toggleable="lg" type="dark" variant="info">
          <b-navbar-brand v-if="showDash == true">
            <h4 class="page-title" v-if="employeeName != ''">
              Welcome <small>{{ employeeName }}</small>
            </h4>
          </b-navbar-brand>
        </b-navbar>
      </b-card>
    </section>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
    ></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
// import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  lastVisitPage,
} from "../../helper/collection";

export default {
  beforeMount() {
         this.$store.dispatch(
        "common/setAllPODList",
        JSON.stringify({
          itemCode: "PODList",
           type:'Normal',
        Territory:'',
        })
      );
    this.getCurrentLastDate();
    lastVisitPage(this.$router.history.current.fullPath);
    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/ffseaExpdashboard"
      );
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewTypeSize("0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }

    // if (
    //   this.$sessionsStorage.get("loginId") != undefined &&
    //   this.$sessionsStorage.get("loginId") != ""
    // ) {
      // if (
      //   (this.$sessionsStorage.get("designation") == "Admin" &&
      //     this.$sessionsStorage.get("nameUser") == "Bhavneesh") ||
      //   (this.$sessionsStorage.get("designation") == "Admin" &&
      //     this.$sessionsStorage.get("nameUser") == "Aaryav")
      // ) {
        // this.$store.dispatch("setCurrentRoute", "/ffseaExpdashboard");
        // this.viewTypeSize("0", "1", "1");
      // } else {
      //   this.$router.push({
      //     path: "/dashboard",
      //   });
      // }
    // } else {
    //   this.$router.push({
    //     path: "/Login/",
    //   });
    // }
  },
  mounted() {},

  beforeDestroy() {},
  destroyed() {},
  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
  },
  computed: {},
  data() {
    return {
      getPortDischargeList:[],
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      branchList:[],
      branchfilter:"",
      clientMaster: [],
      clientIdFilter: "",
      PODfilter:"",
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openLeft: "left",
      showCal: false,
      showDash: true,
      slinevisible:false,
      clientvisible:false,
      branchvisible:false,
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      showgraphsContainer: false,
      showgraphsRev: false,
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      employeeName: "",
      employeeLoc: "",
      cunvertUSD: "75",
      calculatGraphRevenue: "75",
      totalExec: "",
      TotalShippedContEXPTUES:"",
      totalContainerShiped: "",
      TotalShippedContEXP: "",
      Tot20STDTypeCount: "",
      Tot40STDTypeCount: "",
      TotLCL_Container_TotalShippedCont: "",
      Tot20STDTUESTypeCount: "",
      Tot40STDTUESTypeCount: "",
      TotLCLTUES_Container_TotalShippedCont: "",
      totalSlineHtmlCont:'',
      totalHtmlCont:"",
      totalCLIENTHtmlCont:"",
      top10ClientWExportData:[],
      Comb_BranchCont:"",
      ContainertTypetemp_arr:'',

      CustomRevenue: "",
      TPTRevenue: "",
      totalTallyAddedRevenueSum: "",
      AEDRates: 20.42,
      JODRates: 105.75,
      CADRates: 55.21,
      ZARRates: 4.48,
      GBPRates: 94.16,
      EURORates: 85.62,
      USDRates: 74.98,
      backendAmountUSD: "",
      topShippingLineContainerExportData:[],
      topClientWiseContainerExportData:[],
      topBranchWiseContainerExportData:[],
      top10ContainerTypeExportData:[],
      top10BranchWiseBaseContainerTyperow:[],
      topBranchContainerTypeCountData:[],
      top10BranchesExportData:[],
      top10SlinesExportData:[],
      allContMyAll:[],
      totRowContCount:'0',
      totColContCount:'0',
      totTuesContCount:'0',

      isLoading: false,
      series: [],
      chartOptions: {
        plotOptions: {
          pie: {
            // customScale: 1.0
            // size: 200
          },
        },
        chart: {
          width: 200,
          type: "pie",
        },
        labels: [],

        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },

      seriesClientRev: [
        {
          name: "Ammount",
          data: [],
        },
      ],
      chartOptionsShippingLine: {
        annotations: {},
        chart: {
          height: 350,
          type: "bar",
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -30,
          },
          categories: [],
          tickPlacement: "on",
        },
        yaxis: {
          title: {
            text: "Ammount (INR)",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100],
          },
        },
      },

      chartOptionsClientReven: {
        annotations: {},
        chart: {
          height: 350,
          type: "bar",
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -30,
          },
          categories: [],
          tickPlacement: "on",
        },
        yaxis: {
          title: {
            text: "Ammount (INR)",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100],
          },
        },
      },

      chartOptionsConBar: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: true,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        xaxis: {
          categories: [],
        },
        legend: {
          position: "bottom",
          offsetY: 10,
        },
        fill: {
          opacity: 1,
        },
      },
      seriesExCom: [
        {
          name: "No.of Times Used",
          data: [],
        },
      ],
      chartOptionsExCom: {
        annotations: {},
        chart: {
          height: 350,
          type: "bar",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -35,
          },
          categories: [],
          tickPlacement: "off",
        },
        yaxis: {
          title: {
            text: "No. of Times Used",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100],
          },
        },
      },
      seriesShipBar: [
        {
          name: "No.of Container Shiped",
          data: [],
        },
      ],
      chartOptionsShipBar: {
        annotations: {},
        chart: {
          height: 350,
          type: "bar",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -35,
          },
          categories: [],
          tickPlacement: "on",
        },
        yaxis: {
          title: {
            text: "No. of Container Shipped",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100],
          },
        },
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
    };
  },
  methods: {
      getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
              this.getPortDischargeList = result;
            }
          }
        });
        console.log("self[vmodelArray]=>",self)
        
      }
    },
    ClientDetails(ClientID){
      // console.log("Happy Singh ClientID=>",ClientID);
    },
    ViewClientDetails(ClientID){
      if(ClientID !=''){
        this.$sessionsStorage.set("ffexpclientDash","");
        this.$sessionsStorage.set("ffexpclientDash",ClientID);
        // console.log("ViewClientDetails Happy Singh ClientID=>",ClientID);
        this.$router.push({
          path: "/ffexpdash/ffExpCleintdash",
        });
      }
    },
    ViewSlineDetails(SlineId){
      if(SlineId !=''){
        this.$sessionsStorage.set("ffexpSlienDash","");
        this.$sessionsStorage.set("ffexpSlienDash",SlineId);
        this.$router.push({
          path: "/ffexpdash/ffExpSlinedash",
        });
      }
    },
    branchvisibleFun(){
      if(this.topBranchWiseContainerExportData.length>10){
        if(this.branchvisible == true){
          this.branchvisible = false;
        }else{
          this.branchvisible = true;
        }
      }
    },
    clientvisibleFun(){
      if(this.topClientWiseContainerExportData.length>10){
        if(this.clientvisible == true){
          this.clientvisible = false;
        }else{
          this.clientvisible = true;
        }
      }
    },
    slinevisibleFun(){
      if(this.topShippingLineContainerExportData.length>10){
        if(this.slinevisible == true){
          this.slinevisible = false;
        }else{
          this.slinevisible = true;
        }
      }
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      this.getPortDischargeList = this.$store.getters["common/getAllPODList"].length>0?this.$store.getters["common/getAllPODList"]:[];
    },
    gotToFullClientReports() {
      this.$router.push({
        path: "/dashboard/clientProfile",
      });
    },
    changeNumberFormat(num) {
      if (num > 9999999) {
        return Math.abs(num) > 9999999
          ? Math.sign(num) * (Math.abs(num) / 10000000).toFixed(2) + " Crore"
          : Math.sign(num) * Math.abs(num);
      } else if (num > 99999) {
        return Math.abs(num) > 99999
          ? Math.sign(num) * (Math.abs(num) / 100000).toFixed(2) + " Lakhs"
          : Math.sign(num) * Math.abs(num);
      } else if (num > 999) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(2) + " Thousand"
          : Math.sign(num) * Math.abs(num);
      } else {
        return num;
      }
    },

    convertCurrency(ID) {
      if (ID == "USD") {
        this.finalAmountUSD =
          parseInt(this.backendAmountUSD) * parseInt(this.cunvertUSD) + " INR";
      }
      if (this.cunvertUSD == "") {
        this.finalAmountUSD = this.backendAmountUSD;
      }
    },
    zeroPadding(num, digit) {
      var zero = "";
      for (var i = 0; i < digit; i++) {
        zero += "0";
      }
      return (zero + num).slice(-digit);
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewTypeSize("0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set(
        "oldRoute",
        this.$router.history.current.fullPath
      );
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewTypeSize("0", CURRENT, "2", event);
    },
    viewTypeSize() {
      this.isLoading = true;
      this.showgraphsRev = false;
      this.showDash = true;
      this.slinevisible=false,
      this.clientvisible=false,
      this.branchvisible=false,
      this.chartOptionsClientReven.xaxis.categories = [];
      this.chartOptions.labels = [];
      this.topShippingLineContainerExportData = [];
      this.topClientWiseContainerExportData = [];
      this.topBranchWiseContainerExportData = [];
      this.top10ContainerTypeExportData = [];
      this.top10BranchWiseBaseContainerTyperow = [];
      this.topBranchContainerTypeCountData=[];
      this.allContMyAll = [];
      this.top10BranchesExportData = [];
      this.top10SlinesExportData = [];
      this.series = [];
      this.seriesClientRev[0].data = [];
      this.chartOptionsShipBar.xaxis.categories = [];
      this.totalHtmlCont = "";
      this.totalSlineHtmlCont="";
      this.Comb_BranchCont = [];
      this.ContainertTypetemp_arr = [];
      this.clientMaster = [];
      this.totalCLIENTHtmlCont="";
      this.top10ClientWExportData=[];
      this.branchList=[];
      this.totalExec = 0;
      this.TotalShippedContEXPTUES = 0;
      // this.branchfilter="";

      this.totRowContCount='0';
      this.totColContCount='0';
      this.totTuesContCount='0';

      let type_Size = {
        DASH: "DASH",
        dateRange: this.dateRange,
        clientIdFilter:this.clientIdFilter,
        PODfilter:this.PODfilter,
        branchfilter:this.branchfilter,
      };
      // console.log("type_Size Happy Singh",type_Size);

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/getFFSeaExpDashboardData1.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            // console.log("Priyanshu Singh=>",data);
            if (data.msg == "Invalid Token") {
              this.$sessionsStorage.set("loginId", "");
              this.$store.dispatch("setCurrentRoute", "/Login/");
              this.$router.push({
                path: "/Login/",
              });
            } else {
              // console.log("Priyanshu Singh=>",data);
              if (data.clientMaster.length > 0) {
                  this.clientMaster = data.clientMaster;
              }
              if (data.branchList.length > 0) {
                  this.branchList = data.branchList;
              }
              // this.totalExec = data.totalExec;
              if (data.topShippingLineContainerExportData.length > 0) {
                this.topShippingLineContainerExportData = data.topShippingLineContainerExportData;
                this.chartOptionsExCom.xaxis.categories = data.ShippingLineExport;
                if(data.ContainerCount !=''&&data.ContainerCount !='undefined'&&data.ContainerCount !='null'&&data.ContainerCount !=undefined&&data.ContainerCount !=null){
                  this.seriesExCom[0].data = data.ContainerCount;
                }
              }

              if (data.topClientWiseContainerExportData.length > 0) {
                this.topClientWiseContainerExportData = data.topClientWiseContainerExportData;
                this.chartOptionsExCom.xaxis.categories = data.ClientWiseExport;
                if(data.ClientContainerCount !=''&&data.ClientContainerCount !='undefined'&&data.ClientContainerCount !='null'&&data.ClientContainerCount !=undefined&&data.ClientContainerCount !=null){
                  this.seriesExCom[0].data = data.ClientContainerCount;
                }
              }

              if (data.topBranchWiseContainerExportData.length > 0) {
                this.topBranchWiseContainerExportData = data.topBranchWiseContainerExportData;
                this.chartOptionsExCom.xaxis.categories = data.BranchWiseExport;
                if(data.BranchContainerCount !=''&&data.BranchContainerCount !='undefined'&&data.BranchContainerCount !='null'&&data.BranchContainerCount !=undefined&&data.BranchContainerCount !=null){
                  this.seriesExCom[0].data = data.BranchContainerCount;
                }
              }
              // if(data.Comb_BranchCont.length>0){
              //   this.Comb_BranchCont = data.Comb_BranchCont;
              // }
              // if(data.ContainertTypetemp_arr.length>0){
              //   this.ContainertTypetemp_arr = data.ContainertTypetemp_arr;
              // }
              
              if (data.top10ContainerTypeExportData.length > 0) {
                this.top10ContainerTypeExportData = data.top10ContainerTypeExportData;
              }
              if (data.top10BranchWiseBaseContainerTyperow.length > 0) {
                this.top10BranchWiseBaseContainerTyperow = data.top10BranchWiseBaseContainerTyperow;
              }
              if(data.totalHtmlCont !=''){
                this.totalHtmlCont = data.totalHtmlCont;
              }
              if(data.totalSlineHtmlCont !=''){
                this.totalSlineHtmlCont = data.totalSlineHtmlCont;
              }
               if (data.top10SlinesExportData.length > 0) {
                this.top10SlinesExportData = data.top10SlinesExportData;
              }
              if(data.totalCLIENTHtmlCont !=''){
                this.totalCLIENTHtmlCont = data.totalCLIENTHtmlCont;
              }
              if (data.top10ClientWExportData.length > 0) {
                this.top10ClientWExportData = data.top10ClientWExportData;
              }
              let NewCOntType = ['BRANCH/CONTAINER TYPE'];
              let allCont = [];
              // if (data.topBranchContainerTypeCountData ) {
              //   // this.topBranchContainerTypeCountData = object.keys(data.topBranchContainerTypeCountData).map((key) => [Number(key), obj[key]]);
              //   this.topBranchContainerTypeCountData = Object.entries(data.topBranchContainerTypeCountData)
              //   let objj = []
                
              //   data.top10ContainerTypeExportData.forEach(v => {
              //     Object.entries(data.topBranchContainerTypeCountData).forEach(o => {
              //       NewCOntType.push(v.containerType);
              //       if(v.containerTypeId == o.containerTypeId){
              //       }
              //     })
              //   })
              //   var unique = NewCOntType.filter(function(itm, i, NewCOntType) {
              //       return i == NewCOntType.indexOf(itm);
              //   });
              // }
            // data.top10BranchesExportData.forEach(B => {
            //   data.top10ContainerTypeExportData.forEach(v => {
            //   Object.entries(data.topBranchContainerTypeCountData).forEach(BC => {
            //     if(B.mainLocation == BC[0]){
            //       if(BC[1] != undefined && BC[1] !=''){
            //       BC[1].forEach(BNC => {
            //         if(v.containerTypeId ==BNC.containerTypeId){
            //           allCont.push({
            //               branch:B.mainLocation,
            //               containerType:BNC.containerType,
            //               containerTypeId:BNC.containerTypeId,
            //               count: BNC.BranchContainerCount,
            //           });
            //         }else{
            //         // allCont.push(0);
            //         }
            //       });
            //       // let newObj = {
            //       //   B.mainLocation,
            //       // };
            //       }else{
            //       // allCont.push(0);
            //       }
            //     }
            //   });
            //   });
            // });
            // this.allContMyAll = allCont;

              if (data.top10BranchesExportData.length > 0) {
                this.top10BranchesExportData = data.top10BranchesExportData;
              }
              // console.log("data.userDetails",data.userDetails);
              if (data.userDetails.length > 0) {
                if(data.userDetails[0].designation == 'Admin'){
                  // this.branchfilter = '';
                }else{
                  this.branchfilter = data.userDetails[0].baseLocation;
                }
                
                if (data.userDetails[0].dashBoardPermission == "Yes") {
                  this.showDash = true;
                } else {
                  this.showDash = true;
                  if (data.userDetails[0].type == "1") {
                    this.employeeName =
                      data.userDetails[0].employeeName.toUpperCase();
                    this.employeeLoc =
                      data.userDetails[0].employeeLoc.toUpperCase();
                  }
                }
              }
              this.totalExec = data.totalExec;
              this.TotalShippedContEXP = data.TotalShippedContEXP;
              this.TotalShippedContEXPTUES = data.TotalShippedContEXPTUES;
              
              this.Tot20STDTypeCount = data.TotalShippedCont20EXP;
              this.Tot40STDTypeCount = data.TotalShippedCont40EXP;
              this.TotLCL_Container_TotalShippedCont = data.TotalShippedContLCLEXP;

              this.Tot20STDTUESTypeCount = parseInt(data.TotalShippedCont20EXP)*1;
              this.Tot40STDTUESTypeCount = parseInt(data.TotalShippedCont40EXP)*2;
              this.TotLCLTUES_Container_TotalShippedCont = data.TotalShippedContLCLEXP;

              // this.Tot20STDTypeCount = data.Tot20STDTypeCount;
              // this.Tot40STDTypeCount = data.Tot40STDTypeCount;
              // this.TotLCL_Container_TotalShippedCont = data.TotLCL_Container_TotalShippedCont;

              // this.Tot20STDTUESTypeCount = parseInt(data.Tot20STDTypeCount)*1;
              // this.Tot40STDTUESTypeCount = parseInt(data.Tot40STDTypeCount)*2;
              // this.TotLCLTUES_Container_TotalShippedCont = data.TotLCL_Container_TotalShippedCont;
              // this.totalTallyAddedRevenueSum = this.changeNumberFormat(parseFloat( data.totalTallyAddedRevenueSum)) ;
              this.totalTallyAddedRevenueSum =
                this.changeNumberFormat(
                  parseFloat(data.totalTallyAddedRevenueSum)
                ) +
                " + ₹" +
                this.changeNumberFormat(parseFloat(data.total_GstVal)) +
                " = ₹" +
                this.changeNumberFormat(
                  parseFloat(data.total_GstRevenueSumVal)
                );

              // top Container Type chart

              this.series = data.TotalExecutionChartData;
              for (
                let q = 0;
                q < data.TotalExecutionChartLabelData.length;
                q++
              ) {
                this.chartOptions.labels.push(
                  data.TotalExecutionChartLabelData[q]
                );
              }

              this.showgraphsContainer = true;
              this.showgraphsRev = true;

              this.isLoading = false;
            }
          }
        })
        .catch((error) => {});
    },
    previousPage() {
      window.history.go(-1);
    },
    dashboardReports() {
      this.$router.push({
        path: "/dashboard/dashboardReports",
      });
    },
    randomValue() {
      this.value = Math.random() * this.max;
    },

    // Added By Priyanshu Singh Start
    download() {
      let windowHeight = window.outerHeight;
      let windowWidth = window.outerWidth;

      let pdf = new jsPDF();

      let canvasElement = document.createElement("canvas");
      canvasElement.width = 4000;
      canvasElement.height = 4000;

      html2canvas(this.$refs.Dashboardpdf, {
        canvas: canvasElement,
        width: windowWidth,
        height: windowHeight,
      })
        .then((canvas) => {
          const img = canvas.toDataURL("image/jpeg", 5);
          document.body.appendChild(canvas);
          pdf.addImage(img, "JPEG", 10, 10);
          pdf.save("sample.pdf");

          alert("works");
        })
        .catch((err) => {
          alert("error");
        });
    },
    getPDF() {
      var HTML_Width = $("#Dashboardpdf").width();
      var HTML_Height = $("#Dashboardpdf").height();

      var top_left_margin = 15;
      var PDF_Width = HTML_Width + top_left_margin * 2;
      var PDF_Height = PDF_Width * 1.5 + top_left_margin * 2;
      var canvas_image_width = HTML_Width;
      var canvas_image_height = HTML_Height;

      var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

      html2canvas($("#Dashboardpdf")[0], { allowTaint: true }).then(function (
        canvas
      ) {
        canvas.getContext("2d");

        // console.log(canvas.height + "  " + canvas.width);

        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF("p", "pt", [PDF_Width, PDF_Height]);
        pdf.addImage(
          imgData,
          "JPG",
          top_left_margin,
          top_left_margin,
          canvas_image_width,
          canvas_image_height
        );

        for (var i = 1; i <= totalPDFPages; i++) {
          pdf.addPage(PDF_Width, PDF_Height);
          pdf.addImage(
            imgData,
            "JPG",
            top_left_margin,
            -(PDF_Height * i) + top_left_margin * 4,
            canvas_image_width,
            canvas_image_height
          );
        }
        var date = new Date();
        var timestamp = date.getTime();

        pdf.save("FF_Dashboard_Document_"+timestamp+".pdf");
      });
    },

    // Added By Priyanshu Singh End
  },
};
</script>

<style scoped>
.topFiveHeight {
  height: 315px !important;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-top: 1px solid #ffffff !important;
}
.mainCard {
  display: flex;
  margin-bottom: 2rem;
  justify-content: space-between;
  padding: 0;
  border-radius: 10px;
  position: relative;
  min-height: 50px;
  border-bottom: 1px solid #eee !important;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: none !important;
}
.page-header {
  display: flex;
  align-items: center;
  margin: 1.5rem 2rem 1.5rem;
  justify-content: space-between;
  padding: 0;
  border-radius: 3px;
  position: relative;
  min-height: 50px;
  border-bottom: 1px solid #eee !important;
}
.page-title {
  margin: 0;
  font-size: 25px;
  font-weight: 600;
  line-height: 2.5rem;
  position: relative;
  color: #2f2752;
}
.subpage-title {
  font-weight: 300;
  color: #43377b;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.topDivCard {
  margin: 1.5rem 2rem 1.5rem;

  position: relative;

  display: flex;

  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  box-shadow: -8px 12px 18px 0 rgba(25, 42, 70, 0.13);
  border-radius: 3px;
  border: 1px solid transparent;
  margin-bottom: 1.5rem;
  width: 100%;
}
.mb-3 {
  margin: 1.5rem 1rem 1.5rem;
  margin-bottom: 0rem !important;
  font-weight: 600 !important;
  color: #2f2752;
}
.mb-2 {
  margin-bottom: 0 !important;
  font-weight: 700 !important;
}
.mb-4 {
  margin-bottom: -0.5rem !important;
  font-weight: 700 !important;
}
.col-lg-6 {
  width: 49%;
}
.col-lg-4 {
  width: 32.6%;
}
</style>


	


// WEBPACK FOOTER //
// ffDashboard.vue?e753bfb8